import { styled } from '@mui/material';
import clsx from 'clsx';
import { MessageWarningIcon } from '../../theme/icons';
import { appStyles } from '../../theme/appStyles';

export interface CtrlErrorWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    error?: string;
}

const ErrorSpan = styled('span')(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    columnGap: 4,
    color: appStyles.statusColor.errorMain,
    marginTop: theme.spacing(0.5),
    "& svg": {
        width: 12,
        height: 12,
    }
}));

function CtrlErrorWrapperComponent({ error, children, className, ...rest }: CtrlErrorWrapperProps) {
    return (
        <>
            <div {...rest} className={clsx(className, {"isError": error})}>
                {children}
            </div>
            {error && <ErrorSpan><MessageWarningIcon/> {error}</ErrorSpan>}
        </>
    );
}

export const CtrlErrorWrapper = styled(CtrlErrorWrapperComponent, { name: 'CtrlErrorWrapper' })(({ theme }) => ({
    display: "inline-block",
    "&.isError": {
        padding: 4,
    }
}))